/**
 * Which input a picked photo came through (ADR-0059): the camera's was taken now, a file's
 * earlier. The inputs know it only at the moment they deliver the file, and the file then
 * travels — through the workspace's inbox, a page, a hook — to whatever makes a capture of it.
 * So the source is kept beside the file itself, where no hand-over on the way can drop it.
 *
 * A file nobody tagged — dropped on the page, pasted — reads as a file: nothing is called
 * taken now by accident.
 */
export type PhotoSource = 'camera' | 'file'

const SOURCES = new WeakMap<Blob, PhotoSource>()

/** Called by the inputs as they deliver a file. */
export function tagPhotoSource(file: Blob, source: PhotoSource): void {
  SOURCES.set(file, source)
}

export const photoSource = (file: Blob): PhotoSource => SOURCES.get(file) ?? 'file'
